var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMenuDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 16.316,
    viewBox: "0 0 15.5 16.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57544",
    "data-name": "Group 57544",
    transform: "translate(46.5 -172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.934,7.261V1.713C6.934.489,6.412,0,5.115,0h-3.3C.522,0,0,.489,0,1.713V7.261C0,8.484.522,8.974,1.819,8.974h3.3C6.412,8.974,6.934,8.484,6.934,7.261Z",
    transform: "translate(-37.934 172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M6.934,1.713V7.261c0,1.224-.522,1.713-1.819,1.713h-3.3C.522,8.974,0,8.484,0,7.261V1.713C0,.489.522,0,1.819,0h3.3C6.412,0,6.934.489,6.934,1.713Z",
    transform: "translate(-46.5 179.342)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M6.934,4V1.713C6.934.489,6.412,0,5.115,0h-3.3C.522,0,0,.489,0,1.713V4C0,5.221.522,5.711,1.819,5.711h3.3C6.412,5.711,6.934,5.221,6.934,4Z",
    transform: "translate(-37.934 182.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M6.934,4V1.713C6.934.489,6.412,0,5.115,0h-3.3C.522,0,0,.489,0,1.713V4C0,5.221.522,5.711,1.819,5.711h3.3C6.412,5.711,6.934,5.221,6.934,4Z",
    transform: "translate(-46.5 172)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuDashboard);
export default __webpack_public_path__ + "static/media/icon-menu-dashboard.9ab9f2eebd15b4730e883957730d21b3.svg";
export { ForwardRef as ReactComponent };